import DeleteAccountModal from "./DeleteAccountModal";

export default DeleteAccountModal;

export * from "./DeleteAccountModal";
